import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ApplicantContextStore } from '../../shared/stores/applicant-context/applicant-context.store';
import { ClientStore } from '../../shared/stores/client/client.store';
import { environment } from '../../../environments/environment';

function stripPathSuffix(url: string, suffix: string): string {
  const index = url.indexOf(suffix);
  return index === -1 ? url : url.slice(0, index);
}

const factFindDomainBaseUrl = stripPathSuffix(environment.factFind!.sectionTypes, '/sectiontypes');
const factFindDataBaseUrl = stripPathSuffix(environment.factFind!.load, '/load/');

function isFactFindRequest(url: string): boolean {
  return url.startsWith(factFindDomainBaseUrl) || url.startsWith(factFindDataBaseUrl);
}

export const brokerageHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const clientStore = inject(ClientStore);
  const applicantContextStore = inject(ApplicantContextStore);
  const client = clientStore.client();
  const brokerageId = client?.brokerageId;
  const authenticatedClientId = client?.clientId;
  const targetClientId = isFactFindRequest(req.url)
    ? applicantContextStore.activeClientId() ?? authenticatedClientId
    : authenticatedClientId;

  if (
    brokerageId &&
    (req.url.startsWith(environment.gatewayDomain) ||
      req.url.startsWith(factFindDomainBaseUrl) ||
      req.url.startsWith(factFindDataBaseUrl) ||
      req.url.startsWith('http://localhost'))
  ) {
    const headers: Record<string, string> = {
      'smt-target-brokerage': brokerageId,
    };
    if (targetClientId != null) {
      headers['smt-target-client'] = targetClientId.toString();
    }
    const cloned = req.clone({ setHeaders: headers });
    return next(cloned);
  }

  return next(req);
};
